// =====================================================
// 产品系列卡片组件
// =====================================================

import React from 'react';
import { ChevronRight, Folder, Edit2, Trash2 } from 'lucide-react';
import type { ProductSeries } from '../../types/hierarchy';

interface SeriesCardProps {
  series: ProductSeries;
  onClick: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

export function SeriesCard({ series, onClick, onEdit, onDelete }: SeriesCardProps) {
  return (
    <div
      className="group bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg hover:border-blue-200 transition-all cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start gap-4">
        {/* 图标 */}
        <div className="w-12 h-12 bg-gradient-to-br from-yellow-100 to-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
          {series.image_url ? (
            <img
              src={series.image_url}
              alt={series.name}
              className="w-8 h-8 object-contain"
            />
          ) : (
            <Folder className="w-6 h-6 text-yellow-600" />
          )}
        </div>

        {/* 信息 */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-gray-900 truncate">{series.name}</h3>
            <ChevronRight className="w-4 h-4 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>
          {series.name_en && (
            <p className="text-sm text-gray-500 truncate">{series.name_en}</p>
          )}
          {series.description && (
            <p className="text-sm text-gray-400 truncate mt-1">{series.description}</p>
          )}
          
          {/* 统计 */}
          <div className="flex items-center gap-3 mt-2 text-xs text-gray-400">
            <span>{series.family_count || 0} 产品族</span>
            <span>{series.model_count || 0} 型号</span>
          </div>
        </div>

        {/* 操作按钮 */}
        {(onEdit || onDelete) && (
          <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            {onEdit && (
              <button
                onClick={(e) => { e.stopPropagation(); onEdit(); }}
                className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <Edit2 className="w-4 h-4 text-gray-400" />
              </button>
            )}
            {onDelete && (
              <button
                onClick={(e) => { e.stopPropagation(); onDelete(); }}
                className="p-1.5 hover:bg-red-50 rounded-lg transition-colors"
              >
                <Trash2 className="w-4 h-4 text-red-400" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SeriesCard;
